import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/app-constant';
import { HttpService } from '../../service/http/http.service'
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-external-user-link-of360',
  templateUrl: './external-user-link-of360.component.html',
  styleUrls: ['./external-user-link-of360.component.scss'],
})
export class ExternalUserLinkOf360Component  implements OnInit {
  selectedTemplateColorCode: any = '#F6921E';
  token:any;
  companyName:any;
  email:any;
  userName:any;
  templateName:any;
  questions:any=[];
  ratings:any=[];
  selectedTemplateColorName: any = 'Red';
  selectedtemplateBgColor: any;
  templateColorList = [
    {
      stripcolor: "#db4437",
      backgroundColor: "#fae3e1",
      colorName: "Red"
    },
    {
      stripcolor: "#673ab7",
      backgroundColor: "#f0ebf8",
      colorName: "Purple"
    },
    {
      stripcolor: "#3f51b5",
      backgroundColor: "#eceef8",
      colorName: "Indigo"
    }, {
      stripcolor: "#4285f4",
      backgroundColor: "#e3edfd",
      colorName: "Blue"
    },
    {
      stripcolor: "#03a9f4",
      backgroundColor: "#d9f2fd",
      colorName: "Light Blue"
    },
    {
      stripcolor: "#00bcd4",
      backgroundColor: "#d9f5f9",
      colorName: "Cyan"
    },
    {
      stripcolor: "#ff5722",
      backgroundColor: "#ffe6de",
      colorName: "Red Orange"
    },

    {
      stripcolor: "#ff9800",
      backgroundColor: "#fff0d9",
      colorName: "Orange"
    },
    {
      stripcolor: "#009688",
      backgroundColor: "#d9efed",
      colorName: "Teal"
    },
    {
      stripcolor: "#4caf50",
      backgroundColor: "#e4f3e5",
      colorName: "Green"
    },
    {
      stripcolor: "#607d8b",
      backgroundColor: "#e7ecee",
      colorName: "Blue Gray"
    },
    {
      stripcolor: "#9e9e9e",
      backgroundColor: "#f0f0f0",
      colorName: "Gray"
    },
  ]
  reviewName:any;
  userLoggedId:any;
  reviewId:any;
  userId:any;
  constructor(private httpService: HttpService, private config: Config,private activatedroute: ActivatedRoute,
    public dialog: MatDialog, private router:Router
  ) { }

  ngOnInit() {
    
    this.activatedroute.queryParams.subscribe((params: any) => {
      this.token = params?.token
    })
    this.getQuestionForExternalUser();
  } 
  getQuestionForExternalUser(){
    this.httpService.callGetServiceWithoutToken(this.config.getQuestionForExternalUser + this.token).subscribe((data: any) => {
      this.companyName = data?.data?.companyName;
      this.email = data?.data?.email;
      this.userName = data?.data?.name;
      this.reviewName = data?.data?.reviewName;
      this.userLoggedId = data?.data?.userLoggedId
      this.userId = data?.data?.userId
      this.reviewId = data?.data?.reviewId
      this.selectedTemplateColorName = data?.data?.templateName ? data?.data?.templateName : 'Red';
      this.templateColorList.forEach((ele: any) => {
        if (ele.colorName == data?.data?.templateName) {
          this.selectedTemplateColorCode = ele.stripcolor;
          this.selectedtemplateBgColor = ele.backgroundColor;
        }
      })
      this.ratings = [];
      data?.data?.ratings?.forEach((ele: any) => {
        if (ele.questionType == 'Rating Based') {
          let obj = {
            id: ele.id,
            questionType: ele.questionType,
            rating: ele.rating,
            ratingDefinition: ele.ratingDefinition
          }
          this.ratings.push(obj)
        }
      })
      this.questions = [];
      data?.data?.questions?.forEach((ele:any)=>{
        let obj = {
          question: ele.question,
          questionType: ele.questionType,
          id: ele.id,
          answer: null
        }
        this.questions.push(obj);
      })
    })
  }

  validateField(question: any) {
    if (!question.answer || question.answer.trim() === '') {
      question.error = true;
    } else {
      question.error = false;
    }
  }

  isFormValid(): boolean {
    return this.questions.every((q: any) => q.answer && q.answer.trim() !== '');
  }

  submitResponse() {
    this.questions.forEach((q: any) => this.validateField(q));
    if (!this.isFormValid()) {
      alert("Please fill out all required fields.");
      return;
    }

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      data: {
        msg: 'Are you sure you want to submit response?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.selectedTemplateColorCode,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe((result:any) => {
      if (result) {
        var questionResponses:any=[];
        this.questions?.forEach((ele:any)=>{
            let obj = {
              "answer": ele.answer,
              "questionId": ele.id
            }
            questionResponses.push(obj);
        })
        const request ={
          "isSubmitted": true,
          "questionResponses": questionResponses,
          "reviewId": this.reviewId,
          "roleType": "External Customer",
          "userId": this.userId,
          "userLogged": this.userLoggedId
        }    
        this.httpService.callPostServiceForLogin(this.config.submitResponse360ExternalUser, request).subscribe((data: any) => {
          const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.selectedTemplateColorCode,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            },
          });
          dialogRef.afterClosed().subscribe((result:any) => {
            if(result){
              this.router.navigate(['/home/hrportal/threeSixtyDegree'])
            }
          })
        })
      }
    });
  }
}
